import React from "react";
import ModalAlert from "../../entity/common/modal-alert";
import ModalConfirm from "../../entity/common/modal-confirm";
import api from "../../services/api";
import moment from "moment";
import { Link } from "react-router-dom";

export default function DetailEmployeeButton(props) {
  window.idEmployee = props.id;
  
  function openModal(idEmployee){
    window.idEmployee = idEmployee;
    document.getElementById("modal-alter-status-employee").click();
  }

  function openModalStatus(idEmployee){
    window.idEmployee = idEmployee;
    document.getElementById("modal-employee-status").click();
  }

  function openModalEditIntegrationDate(e){

    console.log('TARGET:');
    console.log(e);
    
    let id = e.target.dataset.id;
    let date = e.target.dataset.dt;
    
    console.log("ID integração:"+id);
    console.log("Date integração:"+date);

    window.integrationId = id;

    document.getElementById("modal-alter-date-integration").click();
  }

  function compare(a, b) {
    if (a.id > b.id) return -1;
    if (b.id > a.id) return 1;
    return 0;
  }

  function openModalIntegrations(emp){
    window.employee = emp;
    var ancor = document.getElementById("modal-hist-msg");
    ancor.innerHTML = '';
    var integrations = JSON.parse(emp.integrations);
    if(integrations.length <= 0){
      ancor.insertAdjacentHTML("beforeend", "Nenhum registro encontrado!");
    } else {  
      integrations.sort(compare).map(item => {
        ancor.insertAdjacentHTML("beforeend",
          `<b>ID: </b>${item.id}   -   
           <b>Presente: </b>${(item.showedUp) ? 'Sim' : 'Não'}  -    
           <b>Data:</b>${moment(item.validityDate).format("DD/MM/YYYY")}
           <a href="#" id="link_date_${item.id}" data-id="${item.id}" data-dt="${moment(item.validityDate).format("DD/MM/YYYY")}" classname="btn btn-rounded btn-outline-primary">
            <i className="fa fa-pen" title="Editar data de integração"></i>
            Editar
           </a>
           <br>`
        );
        
        //Adicionando evento de click ao link de edição de integrações
        document.getElementById("link_date_"+item.id).addEventListener("click", openModalEditIntegrationDate);
           
      }); 
    }

    document.getElementById("modal-hist").click();
  }

  return (
    <div>
        <Link
          to={`../companies-id/${props.CompanyTypeId}/employee-documents/${props.data.id}`}
          id={props.data.id}
          title={props.data.name}
          rel="noopener noreferrer"
          className="btn btn-rounded btn-outline-info"
        >
          <i className="fa fa-files-o" />
          Documentos
        </Link>
        

        <button
          className="btn mb-2 btn-rounded btn-outline-danger"
          onClick={e => { openModal(props.data.id); } }
        >
          <i className="fa fa-calendar-times-o" />
           Solicitar Integração
        </button>

        <button
          className="btn mb-2 btn-rounded btn-outline-primary"
          id={props.data.id}
          onClick={e => openModalIntegrations(props.data) }
        >
          <i className="fa fa-files-o" />
           Integrações
        </button>

        <button
          className="btn mb-2 btn-rounded btn-outline-warning"
          id={props.data.id}
          onClick={e => openModalStatus(props.data.id) }
        >
          <i className="fa fa-edit" />
           Alterar Status
        </button>


        <div
          id="modal-hist"
          data-toggle="modal"
          data-target=".modal-hist"
        />
        
         {/* Inicio Modal Histórico de Integrações  */}
         <div
          className="modal fade modal-hist"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Histórico de Integrações
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label id="modal-hist-msg">



                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  id="close-modal-hist"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal Histórico de Integrações */}


        
    </div>
  );
}
